(() => {
  if (window.__drvCountup) return;
  window.__drvCountup = true;
  const SEL = '.drv-101__pct, .drv-science__num, .drv-stats__num, .drv-lev__num, .drv-expert__stat-value, .drv-res__num';
  const RE = /\d[\d,]*(?:\.\d+)?/;
  const DUR = 1200;

  const run = (el) => {
    const node = Array.from(el.childNodes).find((n) => n.nodeType === 3 && RE.test(n.nodeValue));
    if (!node) return;
    const full = node.nodeValue;
    const m = full.match(RE);
    const target = parseFloat(m[0].replace(/,/g, ''));
    if (!isFinite(target)) return;
    const dec = (m[0].split('.')[1] || '').length;
    const grouped = m[0].indexOf(',') !== -1;
    const group = (s) => s.replace(/^\d+/, (int) => int.replace(/\B(?=(\d{3})+$)/g, ','));
    const fmt = (v) => full.replace(m[0], grouped ? group(v.toFixed(dec)) : v.toFixed(dec));
    const t0 = performance.now();
    const tick = (t) => {
      const p = Math.min((t - t0) / DUR, 1);
      const e = 1 - Math.pow(1 - p, 3);
      node.nodeValue = fmt(target * e);
      if (p < 1) requestAnimationFrame(tick);
      else node.nodeValue = full;
    };
    requestAnimationFrame(tick);
  };

  let io = null;

  const observe = (scope) => {
    if (!io) return;
    scope.querySelectorAll(SEL).forEach((el) => {
      if (el.dataset.drvCountup === 'on') return;
      el.dataset.drvCountup = 'on';
      io.observe(el);
    });
  };

  const init = () => {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    io = new IntersectionObserver((entries) => {
      for (const en of entries) {
        if (!en.isIntersecting) continue;
        io.unobserve(en.target);
        run(en.target);
      }
    }, { threshold: 0.4 });
    observe(document);
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();

  document.addEventListener('shopify:section:load', (e) => {
    if (!io) init(); else observe(e.target);
  });
})();
